<template>
    <v-app>
        <div class="video-background">
            <video autoplay muted loop playsinline class="video-element">
                <source :src="videoUrl" type="video/mp4">
                Tu navegador no acepta video
            </video>

            <v-container fluid fill-height class="content-overlay">
                <v-row no-gutters>
                    <v-col cols="12" sm="8" md="5" lg="4" xl="4">
                        <v-card class="login-card">
                            <!-- Capçalera -->
                            <div class="login-header white--text pa-4">
                                <span class="titol">Bienvenid@</span>
                            </div>

                            <!-- Formulari -->
                            <v-card-text class="pa-6">
                                <v-form @submit.prevent="handleLogin">
                                    <v-text-field
                                        v-model="email"
                                        label="Email"
                                        outlined
                                        dense
                                        type="email"
                                        class="mb-4"
                                        required
                                    ></v-text-field>

                                    <v-text-field
                                        v-model="password"
                                        label="Contraseña"
                                        outlined
                                        dense
                                        type="password"
                                        class="mb-4"
                                        required
                                    ></v-text-field>

                                    <v-btn
                                        color="grey lighten-2"
                                        dark
                                        small
                                        type="submit"
                                        class="mb-6"
                                    >
                                        Entrar
                                    </v-btn>

                                    <div v-if="error" style="color: red">{{ error }}</div>
                                </v-form>
                            </v-card-text>

                            <!-- Logos -->
                            <v-card-actions>
                                <div class="d-flex justify-space-between align-center" style="width: 100%">
                                    <v-img
                                         :src="logoNegreUrl"
                                        alt="Logo negre"
                                        max-height="30"
                                        width="80"
                                    ></v-img>
                                </div>
                            </v-card-actions>
                        </v-card>
                    </v-col>
                </v-row>
            </v-container>
        </div>
    </v-app>
</template>

<script setup>
import { ref } from 'vue'
import axios from 'axios'
import { useRouter } from 'vue-router'

import videoUrl from '@/assets/videos/video_traycco.mp4'

const router = useRouter()
const email = ref('')
const password = ref('')
const error = ref('')
const logoNegreUrl = '/images/logo_negre.png'

const handleLogin = async () => {
    try {
        error.value = ''

        // Obtenim la CSRF cookie
        await axios.get('/sanctum/csrf-cookie')

        // Login
        const { data } = await axios.post('/api/login', {
            email: email.value,
            password: password.value
        })

        if (!data.token) {
            error.value = 'No s\'ha rebut el token'
            localStorage.removeItem('token')
            return
        }

        localStorage.setItem('token', data.token)

        // Verifiquem autenticació
        const { data: user } = await axios.get('/api/user', {
            headers: {
                'Authorization': `Bearer ${data.token}`
            }
        })

        if (user.role === 'warehouse') {
            await router.push('/dashboard/stock')
        } else {
            await router.push('/dashboard')
        }

    } catch (e) {
        console.error('Error de login:', e)
        error.value = e.response?.data?.message || 'Error d\'autenticació'
        localStorage.removeItem('token')
    }
}
</script>

<style scoped>
.video-background {
    position: relative;
    width: 100%;
    height: 100vh;
    overflow: hidden;
    z-index: 999;
}

.video-element {
    position: absolute;
    width: 100%;
    height: 100%;
    object-fit: cover;
    z-index: -1;
}

.content-overlay {
    position: relative;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
}

.login-card {
    margin-top: 50px;
    margin-left: 50px;
    width: 500px;
    background-color: rgba(255, 255, 255, 0.8);
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.login-header {
    background-color: rgba(33, 33, 33, 0.7); /* Gris fosc */
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    color: white;
    font-size: 18px;
    font-weight: bold;
}

.titol {
    display: block;
}
</style>
